import UserActionError from '@/interfaces/errors/userAction';
import storageConfig from '@/config/storage';
const PREFIX = 'components: Editor:';
const MAX_FILE_SIZE_MB = storageConfig.maxWorkbookSizeMbs;
export const createReadFileError = (prefix, err, fileName) => {
  const readErr = new UserActionError(`${prefix} failed to read file: ${err}`);
  const file = fileName ? `"${fileName}"` : 'that file';
  readErr.userMessage = `Failed to read ${file}. Please check the file and try again.`;
  readErr.code = `${PREFIX}ReadFileError`;
  readErr.stack = err.stack;
  return readErr;
};
export const createParseFileError = (prefix, err, fileName) => {
  const readErr = new UserActionError(`${prefix} failed to parse file: ${err}`);
  const file = fileName ? `"${fileName}"` : 'that file';
  readErr.userMessage = `Failed to convert ${file} into a spreadsheet. Please check the file and try again.`;
  readErr.code = `${PREFIX}ParseFileError`;
  readErr.stack = err.stack;
  return readErr;
};
export const createStyleReadError = (prefix, err, fileName) => {
  const readErr = new UserActionError(`${prefix} failed to read styles: ${err}`);
  const file = fileName ? `"${fileName}"` : 'that file';

  if ((fileName || '').search(/xlsx$/i) > -1) {
    readErr.userMessage = `Failed to read ${file} styles. Please try uploading again.`;
  } else {
    readErr.userMessage = `XLSX file preferred for improved editing experience.`;
  }

  readErr.code = `${PREFIX}ReadStyleError`;
  readErr.stack = err.stack;
  return readErr;
};
export const createSpreadsheetCompileError = (prefix, err) => {
  const readErr = new UserActionError(`${prefix} failed to compile spreadsheet: ${err}`);
  readErr.userMessage = 'Unexpected issue generating the spreadsheet. Please reload the page or contact support.';
  readErr.code = `${PREFIX}CompileFileError`;
  readErr.stack = err.stack;
  return readErr;
};
export const createFileTooBigError = (prefix, fileName) => {
  const fileTooBig = new UserActionError(`${prefix} file too large`);
  const file = fileName ? `"${fileName}"` : 'that file';
  fileTooBig.userMessage = `${file} is too large (max ${MAX_FILE_SIZE_MB}mb). Please reduce the size and try again.`;
  fileTooBig.code = `${PREFIX}FileTooBig`;
  return fileTooBig;
};
export const createBadWorkbookSaveReqError = (prefix, err) => {
  const readErr = new UserActionError(`${prefix} bad request to save workbook: ${err}`);
  readErr.userMessage = 'Request to save workbook was not accepted. Please check your updates and try again or contact support.';
  readErr.code = `${PREFIX}BadSaveRequestError`;
  readErr.stack = err.stack;
  return readErr;
};
export const createUnauthWorkbookSaveReqError = (prefix, err) => {
  const readErr = new UserActionError(`${prefix} unauthorized request to save workbook: ${err}`);
  readErr.userMessage = 'You do not have permission to update this workbook. Please check that you have necessary permission and try again.';
  readErr.code = `${PREFIX}UnauthSaveRequestError`;
  readErr.stack = err.stack;
  return readErr;
};
export const createNotFoundhWorkbookSaveReqError = (prefix, err) => {
  const readErr = new UserActionError(`${prefix} not-found request to save workbook: ${err}`);
  readErr.userMessage = 'Cound not find the record to update. Please try again or contact support for help.';
  readErr.code = `${PREFIX}NotFoundSaveRequestError`;
  readErr.stack = err.stack;
  return readErr;
};
export const createUnknownWorkbookSaveReqError = (prefix, err) => {
  const readErr = new UserActionError(`${prefix} unexpected error saving workbook: ${err}`);
  readErr.userMessage = 'Unexpected system error saving workbook. Please try again or contact support for help.';
  readErr.code = `${PREFIX}UnknownSaveRequestError`;
  readErr.stack = err.stack;
  return readErr;
};
export const createGetFromDriveFileError = (prefix, err, fileName) => {
  const readErr = new UserActionError(`${prefix} failed to load file: ${err}`);
  const file = fileName ? `"${fileName}"` : 'that file';
  readErr.userMessage = `Failed to load ${file}. Please try again.`;
  readErr.code = `${PREFIX}LoadFileError`;
  readErr.stack = err.stack;
  return readErr;
};
export default {
  createReadFileError,
  createParseFileError,
  createStyleReadError,
  createSpreadsheetCompileError,
  createFileTooBigError,
  createBadWorkbookSaveReqError,
  createUnauthWorkbookSaveReqError,
  createNotFoundhWorkbookSaveReqError,
  createUnknownWorkbookSaveReqError,
  createGetFromDriveFileError
};